module.exports = __webpack_public_path__ + "img/gerenciamento-de-projetos.c7161bc4.png";